var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "arrowBackTitle"
  }, "Back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "arrowBackTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0065 6.00002C15.5552 6.00002 16 5.5523 16 5.00002C16 4.44773 15.5552 4.00002 15.0065 4.00002H3.4142L5.70711 1.70711C6.09763 1.31658 6.09763 0.683418 5.70711 0.292893C5.31658 -0.0976311 4.68342 -0.0976311 4.29289 0.292893L0.330434 4.25535C0.141945 4.42551 0.0184258 4.66711 0.00192344 4.93783C-0.000638125 4.97921 -0.00064194 5.02072 0.00191677 5.0621C0.0184039 5.33302 0.142069 5.57479 0.330775 5.74499L4.29289 9.70711C4.68342 10.0976 5.31658 10.0976 5.70711 9.70711C6.09763 9.31658 6.09763 8.68342 5.70711 8.29289L3.41423 6.00002H15.0065Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIcon);
export default __webpack_public_path__ + "static/media/arrowBackIcon.4a91dfe1650ca4b9a5f610426ef2f1e1.svg";
export { ForwardRef as ReactComponent };